import { NullableRecords } from 'types/_common';

type TAppConfigData = NullableRecords<{
  REACT_APP_YANDEX_KEY: string;
  NODE_ENV: string;

  REACT_APP_TALENTS_HOST: string;
  REACT_APP_MDM_HOST: string;
  REACT_APP_REFEREE_HOST: string;
  REACT_APP_TRAVEL_HOST: string;
  REACT_APP_TRANSFER_HOST: string;
  REACT_APP_LICENSE_HOST: string;
  REACT_APP_NOTIFY_HOST: string;
}>;

class AppConfig {
  YANDEX_KEY: number | null = null;
  NODE_ENV: string = '';

  TALENTS_HOST: string = '';
  MDM_HOST: string = '';
  REFEREE_HOST: string = '';
  TRAVEL_HOST: string = '';
  TRANSFER_HOST: string = '';
  LICENSE_HOST: string = '';
  NOTIFY_HOST: string = '';

  setVariables(data: TAppConfigData): void {
    this.YANDEX_KEY = data.REACT_APP_YANDEX_KEY ? Number(data.REACT_APP_YANDEX_KEY) : null;
    this.NODE_ENV = data.NODE_ENV || 'development';

    this.TALENTS_HOST = data.REACT_APP_TALENTS_HOST || '';
    this.MDM_HOST = data.REACT_APP_MDM_HOST || '';
    this.REFEREE_HOST = data.REACT_APP_REFEREE_HOST || '';
    this.TRAVEL_HOST = data.REACT_APP_TRAVEL_HOST || '';
    this.TRANSFER_HOST = data.REACT_APP_TRANSFER_HOST || '';
    this.LICENSE_HOST = data.REACT_APP_LICENSE_HOST || '';
    this.NOTIFY_HOST = data.REACT_APP_NOTIFY_HOST || '';
  }
}
const appConfig = new AppConfig();
export { appConfig };
